import script from "./employee-policy-and-coverages.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-policy-and-coverages.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__